import React from "react"
import { Box, Grid, Container } from "@material-ui/core"
import "../styles/app.scss"
import Logo from "../images/logo.webp"

export default function Layout({ children }) {
  return (
    <Container>
      <Box className="app-header">
        <Box className="app-logo">
          <a href="https://empowermentfoundation.work">
            <img src={Logo} />
          </a>
        </Box>
      </Box>
      {children}
    </Container>
  )
}
